(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3504],{

/***/ 31502:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(83618);
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(13179);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_pages_agencies_agents_list_results_counter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54602);
/* harmony import */ var _components_pages_agencies_agents_list_search__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74297);
/* harmony import */ var _components_pages_agencies_agents_list_List_section__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2505);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(42746);
/* harmony import */ var next_intl__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(next_intl__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _helpers_removeparams__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(57626);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _components_a1_refactor_typography_WsSectionTitleWithThinTitle_copy__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(71099);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(70917);



function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }













var AgentesCollection = function AgentesCollection() {
  var titleT = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__.useTranslations)("title-pages");
  var translation = (0,next_intl__WEBPACK_IMPORTED_MODULE_8__.useTranslations)("collection.certifiedAgents");
  var agentTitle = translation("title") || "";

  var _agentTitle$split = agentTitle.split(" "),
      _agentTitle$split2 = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toArray_js__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_agentTitle$split),
      titleOne = _agentTitle$split2[0],
      titleTwo = _agentTitle$split2[1],
      rest = _agentTitle$split2.slice(2);

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(""),
      search = _useState[0],
      setSearch = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      count = _useState2[0],
      setCount = _useState2[1];

  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
  var config = {
    active: 2,
    setCount: setCount,
    search: search,
    isCollection: true
  };
  var metas = {
    title: titleT("collectionAgents"),
    meta: "Remax Royal, Agente inmobiliario, Agentes inmobiliarios, Agentes Remax, Remax metropolitana, Remax plus, Agente Remax plus, Agencias inmobiliaria, Agentes Remax República Dominicana"
  };
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(react__WEBPACK_IMPORTED_MODULE_2__.Fragment, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("title", null, metas.title), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("meta", {
    name: "keywords",
    content: metas.meta
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("link", {
    rel: "canonical",
    href: (0,_helpers_removeparams__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)("".concat("https://unete.remaxrd.com").concat(router.asPath)),
    key: "canonical"
  })), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ArticleRoot, null, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("section", {
    className: "search"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_components_a1_refactor_typography_WsSectionTitleWithThinTitle_copy__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
    title: rest.join(" "),
    subtitle: "".concat(titleOne, " ").concat(titleTwo)
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)("div", {
    className: "container"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(ContainerSearch, {
    className: "container_title"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_components_pages_agencies_agents_list_search__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
    active: 2,
    setSearch: setSearch
  }))))), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_components_pages_agencies_agents_list_results_counter__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
    active: 2,
    count: count
  }), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_components_pages_agencies_agents_list_List_section__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, config));
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (AgentesCollection);

var Title = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("h1",  true ? {
  target: "e6fqix12"
} : 0)( true ? {
  name: "1jbiwd",
  styles: "font-size:18px;justify-content:center;align-items:center;display:flex;width:100%;margin-bottom:40px;color:var(--color-brand-blue-main)"
} : 0);

var ArticleRoot = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("article",  true ? {
  target: "e6fqix11"
} : 0)( true ? {
  name: "1fwpm12",
  styles: "& .search{padding:55px 0 30px;}@media screen and (max-width: 1299px){& .search{padding-bottom:50px;}}@media screen and (max-width: 500px){padding-top:100px;& .search{padding:25px 0 30px;}}"
} : 0);

var ContainerSearch = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e6fqix10"
} : 0)( true ? {
  name: "1ctqbja",
  styles: "&.container_title{display:flex;flex-direction:column;width:60%;margin:auto;display:flex;justify-content:center;margin-bottom:15px;margin-top:15px;font-size:14px;font-family:var(--font-family);color:var(--color-brand-blue-main);.search_input{border:1px solid #ccc!important;}@media screen and (max-width: 1000px){width:80%;}@media screen and (max-width: 1000px){width:100%;padding:0px 20px;}@media screen and (max-width: 475px){padding:0px 10px;}}"
} : 0);

/***/ }),

/***/ 71099:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71383);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(90948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(70917);


var _templateObject;




function WsSectionTitleWithThinTitle(_ref) {
  var title = _ref.title,
      subtitle = _ref.subtitle,
      color = _ref.color,
      _ref$fontSize = _ref.fontSize,
      fontSize = _ref$fontSize === void 0 ? "1.6rem" : _ref$fontSize;
  return (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    container: true,
    item: true,
    xs: 12,
    justifyContent: "center",
    spacing: 1
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 700,
    color: color
  }, title)), (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
    item: true,
    xs: "auto"
  }, (0,_emotion_react__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(Title, {
    fontSize: fontSize,
    fontWeight: 400,
    color: color
  }, subtitle)));
}

/* harmony default export */ __webpack_exports__["Z"] = (WsSectionTitleWithThinTitle);
var Title = (0,_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_templateObject || (_templateObject = (0,_home_runner_work_websitev2_websitev2_node_modules_next_dist_compiled_babel_runtime_helpers_esm_taggedTemplateLiteral_js__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(["\n  font-size: 1.8rem;\n  @media screen and (max-width: 768px) {\n    font-size: 1.4rem;\n  }\n"])));

/***/ }),

/***/ 61751:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/collection/agentes",
      function () {
        return __webpack_require__(31502);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 14666:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayWithHoles; }
/* harmony export */ });
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

/***/ }),

/***/ 14882:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _nonIterableRest; }
/* harmony export */ });
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

/***/ }),

/***/ 83618:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _toArray; }
/* harmony export */ });
/* harmony import */ var _arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14666);
/* harmony import */ var _iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28811);
/* harmony import */ var _unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2937);
/* harmony import */ var _nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(14882);




function _toArray(arr) {
  return (0,_arrayWithHoles_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(arr) || (0,_iterableToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(arr) || (0,_unsupportedIterableToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(arr) || (0,_nonIterableRest_js__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
}

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,3662,2708,1629,8407,2615,6877,4022,70,3843,1664,8543,2960,3828,5173,6377,5082,2888,179], function() { return __webpack_exec__(61751); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);